import styled from 'styled-components'

export const Hr = styled.hr`
  margin: 25px 0 20px;
  border: 0;
  opacity: 0.3;
  border-top: 1px solid #081377;
`
